import './App.css';
import { Routes, Route } from 'react-router-dom'
import { Navbar, Footer } from './components';
import { ApartmentPage, BasicDeluxePage, BasicStandardPage, BookingPage, ContactPage, ExecutiveSuitePage, ExperiencePage, GalleryPage, GymPage, HomePage, LuxuryDeluxePage, LuxuryRegularPage, LuxuryStandardPage, LuxurySuitePage, PrivacyPolicyPage, RoomPage, SalonPage, SpaPage, TermsPage } from './pages';
import ScrollToTop from './hoc/ScrollToTop';
import NewHomePage from './pages/NewHomePage';
import NewNavbar from './components/NewNavbar';
import ThingsToDoPage from './pages/ThingsToDoPage';
import OgunApartmentPage from './pages/OgunApartmentPage';
import AbujaApartmentPage from './pages/AbujaApartmentPage';

function App() {
  return (
    <div className="font-openSans w-full">
      {/* <Navbar /> */}
      <NewNavbar />
      <ScrollToTop>

        <Routes>
          {/* <Route path='/' element={ <HomePage /> } /> */}
          <Route path='/' element={ <NewHomePage /> } />
          <Route path='/about-us' element={ <ExperiencePage /> } />
          {/* <Route path='/gallery' element={ <GalleryPage /> } /> */}
          {/* <Route path='/gym' element={ <GymPage /> } />
          <Route path='/saloon' element={ <SalonPage /> } />
          <Route path='/spa' element={ <SpaPage /> } /> */}
          <Route path='/apartments/lagos' element={ <ApartmentPage /> } />
          <Route path='/apartments/abuja' element={ <AbujaApartmentPage /> } />
          <Route path='/apartments/ogun' element={ <OgunApartmentPage /> } />
          {/* <Route path='/rooms-and-suites' element={ <RoomPage /> } />
          <Route path='/rooms-and-suites/basic-standard' element={ <BasicStandardPage /> } />
          <Route path='/rooms-and-suites/basic-deluxe' element={ <BasicDeluxePage /> } />
          <Route path='/rooms-and-suites/luxury-regular' element={ <LuxuryRegularPage /> } />
          <Route path='/rooms-and-suites/luxury-standard' element={ <LuxuryStandardPage /> } />
          <Route path='/rooms-and-suites/luxury-deluxe' element={ <LuxuryDeluxePage /> } />
          <Route path='/apartments/:id' element={ <LuxurySuitePage /> } /> */}
          {/* <Route path='/apartments/luxury-suite' element={ <LuxurySuitePage /> } /> */}
          {/* <Route path='/apartments/executive-suite' element={ <ExecutiveSuitePage /> } /> */}
          <Route path='/privacy-policies' element={ <PrivacyPolicyPage /> } />
          <Route path='/terms-and-conditions' element={ <TermsPage /> } />
          {/* <Route path='/contact' element={ <ContactPage /> } /> */}
          <Route path='/booking' element={ <BookingPage /> } />
          <Route path='/things-to-do' element={ <ThingsToDoPage /> } />
        </Routes>
      </ScrollToTop>
      {/* <HomePage /> */}
      <Footer />
    </div>
  );
}

export default App;
